import { ShipmentStatus } from "@/api.types.v2";

const CUSTOMER_CANCELLATION_REQUEST_STATUSES = new Set<string>([
  ShipmentStatus.PENDING_PAYMENT,
  ShipmentStatus.LABEL_READY,
  ShipmentStatus.DROPPED_AT_CARRIER,
  ShipmentStatus.PICKED_UP,
  ShipmentStatus.AT_FACILITY,
  ShipmentStatus.IN_TRANSIT,
  ShipmentStatus.OUT_FOR_DELIVERY,
  ShipmentStatus.AVAILABLE_FOR_PICKUP,
]);

/** Display hint for the server's customer cancellation-request contract. */
export function canRequestCustomerShipmentCancellation(
  status: string | null | undefined
): boolean {
  return Boolean(status && CUSTOMER_CANCELLATION_REQUEST_STATUSES.has(status));
}

export function isPreCollectionShipment(status: string | null): boolean {
  return (
    status === ShipmentStatus.PENDING_PAYMENT ||
    status === ShipmentStatus.LABEL_READY
  );
}

export function canRequestCustomerShipmentChanges(
  status: ShipmentStatus | null | undefined
): boolean {
  return Boolean(
    status &&
      [
        ShipmentStatus.LABEL_READY,
        ShipmentStatus.PICKED_UP,
        ShipmentStatus.IN_TRANSIT,
        ShipmentStatus.OUT_FOR_DELIVERY,
      ].includes(status)
  );
}
